import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { findAssistantReply } from './teamAssistantMessages';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

/** Normalize stored range values for Ant Design DatePicker (dayjs). */
export const normalizePickerDateRange = (dates) => {
  if (!dates) return null;
  const start = dates[0] ? dayjs(dates[0]) : null;
  const end = dates[1] ? dayjs(dates[1]) : null;
  if (!start && !end) return null;
  if (start && !start.isValid()) return null;
  if (end && !end.isValid()) return null;
  return [start, end];
};

export const defaultBrowseFilters = () => ({
  dates: null,
  day: null,
  userId: undefined,
  keyword: '',
  messageRole: 'all',
  replyStatus: 'all',
  activityType: 'all',
  quickPreset: 'all',
});

export const quickRangePresets = {
  all: { key: 'all', label: 'All time', range: () => null },
  today: {
    key: 'today',
    label: 'Today',
    range: () => [dayjs().startOf('day'), dayjs().endOf('day')],
  },
  last7: {
    key: 'last7',
    label: 'Last 7 days',
    range: () => [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')],
  },
  last30: {
    key: 'last30',
    label: 'Last 30 days',
    range: () => [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')],
  },
  last90: {
    key: 'last90',
    label: 'Last 90 days',
    range: () => [dayjs().subtract(89, 'day').startOf('day'), dayjs().endOf('day')],
  },
};

export const inDateRange = (isoDate, dates) => {
  if (!dates || !dates[0] || !dates[1] || !isoDate) return true;
  const t = dayjs(isoDate);
  const start = dayjs(dates[0]);
  const end = dayjs(dates[1]);
  return t.isSameOrAfter(start, 'day') && t.isSameOrBefore(end, 'day');
};

export const matchesKeyword = (text, keyword) => {
  const q = (keyword || '').trim().toLowerCase();
  if (!q) return true;
  return (text || '').toLowerCase().includes(q);
};

export const filterUserMessage = (msg, browse, messages) => {
  if (!msg || msg.role !== 'user') return false;
  if (browse.userId != null && String(msg.user?.id) !== String(browse.userId)) return false;
  if (!inDateRange(msg.created_at, browse.dates)) return false;
  if (!matchesKeyword(msg.content, browse.keyword)) return false;
  if (browse.replyStatus === 'answered') {
    if (!findAssistantReply(messages, msg)) return false;
  }
  if (browse.replyStatus === 'unanswered') {
    if (findAssistantReply(messages, msg)) return false;
  }
  return true;
};

export const filterActivityItem = (item, browse) => {
  if (!item) return false;
  const at = item.at || item.created_at;
  if (!inDateRange(at, browse.dates)) return false;
  if (browse.userId != null && String(item.user?.id) !== String(browse.userId)) return false;
  if (!matchesKeyword(item.summary || item.content, browse.keyword)) return false;
  if (browse.activityType === 'questions' && item.type !== 'question') return false;
  if (browse.activityType === 'replies' && item.type !== 'assistant_reply') return false;
  if (browse.activityType === 'uploads' && item.type !== 'document_upload') return false;
  return true;
};

export const filterDocument = (doc, browse) => {
  if (!doc) return false;
  if (!inDateRange(doc.created_at, browse.dates)) return false;
  if (browse.userId != null && String(doc.user?.id) !== String(browse.userId)) return false;
  if (!matchesKeyword(doc.original_name, browse.keyword)) return false;
  return true;
};

export const countActiveBrowseFilters = (browse) => {
  let n = 0;
  if (browse.day) n += 1;
  else if (browse.dates?.[0] && browse.dates?.[1]) n += 1;
  else if (browse.quickPreset && browse.quickPreset !== 'all') n += 1;
  if (browse.userId != null) n += 1;
  if ((browse.keyword || '').trim()) n += 1;
  if (browse.messageRole && browse.messageRole !== 'all') n += 1;
  if (browse.replyStatus && browse.replyStatus !== 'all') n += 1;
  if (browse.activityType && browse.activityType !== 'all') n += 1;
  return n;
};
